import React from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { Button, Col, Card, CardHeader, CardBody, Row } from 'reactstrap';
import Avatar from '../common/FallBackAvatar';

const grid = 4;

const getItemStyle = (isDragging, draggableStyle) => ({
    // some basic styles to make the items look a bit nicer
    userSelect: 'none',
    padding: 4,
    margin: `0 0 ${grid}px 0`,

    // change background colour if dragging
    background: isDragging ? 'lightgreen' : 'lightgrey',

    // styles we need to apply on draggables
    ...draggableStyle
});

const getListStyle = isDraggingOver => ({
    background: isDraggingOver ? 'lightblue' : 'white',
    padding: 4,
});

const getListStyleHorizontal = isDraggingOver => ({
    background: isDraggingOver ? 'lightblue' : 'white',
    padding: 4,
    overflow: 'auto',
});

class CourseFacultyAssignment extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            isDirty: false
        };
    }

    state = {
        faculty: this.props.faculty,
        isDirty: false
    };

    getAvatar = item =>
        <React.Fragment>
            <Avatar className='avatar-small' alt={item.displayName} image={item.image} />
            <div className='align-self-center font-small'>
                <div className='font-weight-bold'>{item.displayName}</div>
                <div>{item.disciplines}</div>
            </div>
        </React.Fragment>


    onDragEnd = result => {
        const { source, destination } = result;

        // dropped outside the list
        if (!destination) {
            return;
        }
        if (source.droppableId !== destination.droppableId) {

            if (destination.droppableId === 'faculty') {
                this.props.onRemove(this.props.courses.find(x => x.courseId === parseInt(source.droppableId, 10)), this.props.courses.find(x => x.courseId === parseInt(source.droppableId, 10)).faculty[source.index]);
                this.setState({ isDirty: true });
            }
            else
                if (source.droppableId !== 'faculty') {
                    this.props.onAdd(this.props.courses.find(x => x.courseId === parseInt(destination.droppableId, 10)),
                        this.props.courses.find(x => x.courseId === parseInt(source.droppableId, 10)).faculty[source.index]);
                    this.props.onRemove(this.props.courses.find(x => x.courseId === parseInt(source.droppableId, 10)), this.props.courses.find(x => x.courseId === parseInt(source.droppableId, 10)).faculty[source.index]);
                    this.setState({ isDirty: true });
                }
                else {
                    this.props.onAdd(this.props.courses.find(x => x.courseId === parseInt(destination.droppableId, 10)), this.props.faculty[source.index]);
                    this.setState({ isDirty: true });
                }

        }
    };

    getCourseContainers = () => {

        const containers = [];
        this.props.courses.forEach(course => {
            containers.push(
                <Col key={course.courseId} className='col-4 p-1'>
                    <Card>
                        <CardHeader>{course.name}</CardHeader>
                        <CardBody className='p-0 overflow-hidden'>
                            <Droppable droppableId={`${course.courseId}`}>
                                {(provided, snapshot) => (
                                    <div
                                        className= 'droppable'
                                        ref={provided.innerRef}
                                        style={getListStyle(snapshot.isDraggingOver)}>
                                        {course.faculty && course.faculty.map((item, index) => (
                                            <Draggable
                                                key={item.personId}
                                                draggableId={`${course.courseId}${item.personId}`}
                                                index={index}>
                                                {(provided, snapshot) => (
                                                    <div
                                                        className='m-1 rounded d-flex draggable-faculty'
                                                        ref={provided.innerRef}
                                                        {...provided.draggableProps}
                                                        {...provided.dragHandleProps}
                                                        style={getItemStyle(
                                                            snapshot.isDragging,
                                                            provided.draggableProps.style
                                                        )}>
                                                        {this.getAvatar(item)}
                                                    </div>
                                                )}
                                            </Draggable>
                                        ))}
                                        {provided.placeholder}
                                    </div>
                                )}
                            </Droppable>
                        </CardBody>
                    </Card>
                </Col>
            )
        }
        );

        return containers;
    }

    // Normally you would want to split things out into separate components.
    // But in this example everything is just done in one place for simplicity
    render() {
        return (
            <React.Fragment>
            <DragDropContext onDragEnd={this.onDragEnd} >

                <Row className='mr-0 ml-0'>
                    <Col className='p-1 col-3'>
                        <Card>
                            <CardHeader>Available Faculty</CardHeader>
                            <CardBody className='p-0 overflow-hidden'>
                                <Droppable droppableId='faculty'>
                                    {(provided, snapshot) => (
                                        <div
                                            className='m-1 rounded'
                                            ref={provided.innerRef}
                                            style={getListStyleHorizontal(snapshot.isDraggingOver)}>

                                            {this.props.faculty.map((item, index) => (
                                                <Draggable
                                                    key={item.personId}
                                                    draggableId={`${item.personId}`}
                                                    index={index}>
                                                    {(provided, snapshot) => (
                                                        <div
                                                            className='m-1 rounded d-flex'
                                                            ref={provided.innerRef}
                                                            {...provided.draggableProps}
                                                            {...provided.dragHandleProps}
                                                            style={getItemStyle(
                                                                snapshot.isDragging,
                                                                provided.draggableProps.style
                                                            )}>
                                                            {this.getAvatar(item)}
                                                        </div>
                                                    )}
                                                </Draggable>
                                            ))}
                                            {provided.placeholder}
                                        </div>
                                    )}
                                </Droppable>
                            </CardBody>
                        </Card>
                    </Col>
                    <Col className='p-0 m-0'>
                        <Row className='mr-0 ml-0'>
                            {this.getCourseContainers()}
                        </Row>
                    </Col>

                </Row>
            </DragDropContext>
            <Row className='pt-3'>
                <Col className='d-flex flex-row-reverse'>
                        <Button onClick={this.props.handleSave}>Save</Button>
                        <Button className='me-1' onClick={() => this.props.cancelSave(this.state.isDirty)}>Cancel</Button>
                </Col>
            </Row>
          </React.Fragment>
        );
    }
}

export default CourseFacultyAssignment
